quoteModule.controller('vehicleProductsController',
['$scope', '$rootScope', '$mdDialog', 'quoteCreationEvents', 'rateQuoteCoordService', 'rateQuoteScenariosService', 'vehicleProductsProcessingService','providerFeaturesService', 'imSessionVarsService',
function ($scope, $rootScope, $mdDialog, quoteCreationEvents, rateQuoteCoordService, rateQuoteScenariosService, vehicleProductsProcessingService, providerFeaturesService, imSessionVarsService) {
    /*
    The vehicle products controller  retrieves new products once the vehicle data is valid, or retrieves a saved
    quote's products for reviewing. It basically manages the "overall" products listing.
     */
    var self = this;

    $scope.allowDefaultProposal = false;
    $scope.showPrinter = false;
    $scope.printDivs = [];

    //initialization from directive
    this.init = function(element){
        self.$element = element;
        $scope.vehicleProductInfo.haveProducts = false;
        $scope.vehicleData = rateQuoteCoordService.VehicleData;

        providerFeaturesService.getProviderApplicationSetting("AllowDefaultProposal",'false')
        .then(
            function(element){
                $scope.allowDefaultProposal = element.toString().toUpperCase() === "TRUE";
                if ($scope.allowDefaultProposal){
                    $scope.vehicleData.defaultProductsOnly = 'true';
                    rateQuoteCoordService.VehicleData.defaultProductsOnly = 'true';
                }else{
                    rateQuoteCoordService.VehicleData.defaultProductsOnly = 'false';
                }
            }
        );
    };

    $scope.navigationVisible = false;

    //product data in scope
    $scope.vehicleProductInfo = vehicleProductsProcessingService.productData;
    $scope.vehicleProductMessages = {};
    $scope.vehicleData = rateQuoteCoordService.VehicleData;

    $scope.$watch('vehicleProductInfo.haveProducts', function(newVal) {
        if(newVal){
            $rootScope.$broadcast(quoteCreationEvents.productDataComplete, true);
            $scope.productNavigationList = $scope.vehicleProductInfo.allProducts.map(function (product) {
                if (product.PartnerSpecificFields && product.PartnerSpecificFields.FlexFields){
                    product.PartnerSpecificFields.FlexFields.forEach(function (field){
                        if (field.FieldName === 'PRODUCT-MESSAGE'){
                            $scope.vehicleProductMessages[product.InternalProductId] = field.FieldValue;
                        }
                    });
                }
                return {
                    ParentProductTypePartnerCode: product.ParentProductType.PartnerCode,
                    DisplayName: product.DisplayName
                };
            });
        };
    });

    $scope.toggleShowRates = function(productid){
        $scope.vehicleProductInfo.showRates[productid] = !$scope.vehicleProductInfo.showRates[productid];
    }
    $scope.$on(quoteCreationEvents.rateChosen, function(event, args){
       var prodid = args;
        $scope.vehicleProductInfo.showRates[prodid] = false;
    });
    //respond to refresh quote queue event
    $scope.$on(quoteCreationEvents.refreshQuoteQueue, function(event, args) {
        $scope.getQuoteSummaryInfo();
        if (args.prodId)
            $scope.vehicleProductInfo.showRates[args.prodId] = true;
    });
    //respond to refresh quote queue event
    $scope.$on(quoteCreationEvents.loadingExistingQuote, function(event, args) {
        $scope.getQuoteSummaryInfo();
        var currentRateQuotes = rateQuoteCoordService.getRatesForScenarioCode(
            rateQuoteScenariosService.getCurrentScenario());
        if (currentRateQuotes && currentRateQuotes.length > 0){
            currentRateQuotes.forEach(function(nxtRate) {
                $scope.vehicleProductInfo.showRates[nxtRate.RatedProduct.InternalProductId] = false;
            });
        }
        currentRateQuotes = null;
    });
    //display chosen rate summary information for a product
    $scope.getQuoteSummaryInfo = function(){
        var currentRateQuotes = rateQuoteCoordService.getRatesForScenarioCode(
            rateQuoteScenariosService.getCurrentScenario());
        $scope.vehicleProductInfo.rateSummaryData = {};

        if (currentRateQuotes && currentRateQuotes.length > 0){
            currentRateQuotes.forEach(
                function setQuoteSummary(nxtRate){
                    $scope.vehicleProductInfo.rateSummaryData[nxtRate.RatedProduct.InternalProductId] = {
                        coverage : nxtRate.BaseNoUpgradeProductRates ? nxtRate.BaseNoUpgradeProductRates[0].BaseRatedCoverage.DisplayName : nxtRate.RatedCoverage.DisplayName,
                        deductible : nxtRate.BaseNoUpgradeProductRates ? nxtRate.BaseNoUpgradeProductRates[0].BaseRatedDeductible.NumericValue : (nxtRate.RatedDeductible ? nxtRate.RatedDeductible.NumericValue : null),
                        baseTerm : nxtRate.BaseNoUpgradeProductRates ? nxtRate.BaseNoUpgradeProductRates[0].BaseRatedTerm.RatedTerm.DisplayName : null,
                        upgradeCoverage : nxtRate.BaseNoUpgradeProductRates ? nxtRate.RatedCoverage.DisplayName : null,
                        upgradeDeductible : nxtRate.BaseNoUpgradeProductRates ? nxtRate.RatedDeductible.DisplayName : null,
                        retailCost : nxtRate.RatedTerms[0].RetailCost
                    }
            });
        }
        currentRateQuotes = null;
    }
    //if the vehicle data changes, we clear out products
    $scope.$on(quoteCreationEvents.vehicleDataChanged, function(event, args) {
        vehicleProductsProcessingService.clearProducts(false);
    });

    //clear products if vehicle data is error
    $scope.$on(quoteCreationEvents.vehicleDataError, function(event, args) {
        vehicleProductsProcessingService.clearProducts(false);
    });

    $scope.showRates = function(productId) {
        return ($scope.vehicleProductInfo.showRates[productId] /*&& $scope.vehicleProductInfo.rateSummaryData[productId]*/);
    };

    $scope.showProductSettings = function(event, prod) {
        //com-745 : The provider bases profit and all settings on product type and not product (ugh).
        // so we force the productcode for profit settings (pack, display, etc.) to product type
        var useProductType = false;
        providerFeaturesService.getProviderProfitSettingMode()
        .then(
            function(mode){
                useProductType = mode && mode === 'PRODUCTTYPECODE';

                var productCode = prod.InternalProductId;
                var productTypeCode = (prod.ParentProductType || {}).PartnerCode || "";
                var productName = productTypeCode + (productTypeCode ? " - " : "" ) + prod.DisplayName || "";  // prefix with type code IF available
        
                var productInfo = { productCode: productCode, productTypeCode: productTypeCode, productDisplayName: productName };
                if (useProductType){
                    productInfo.productCode = productInfo.productTypeCode;
                    productInfo.productDisplayName = productInfo.productTypeCode;
                }
                showProductSettingsDialog(null, productInfo, "ProfitType");

            }
        )
        if (event) {
            event.stopPropagation();
        }
    };

    // Todo: this function is identical to the one in settings-summary-controller. Refactor to share code.
    // Displays product settings dialog-box.
    function showProductSettingsDialog (event, productInfo, initialView) {

        $mdDialog.show( {
            controller: 'productSettingsDialogController',
            templateUrl: 'app/modules/quote/views/product-settings-dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            controllerAs: 'ctrl',
            bindToController: true,
            locals: { prod: productInfo, initialView: initialView }

        }).then(function() {
            }, function() {
        });

        if (event) {
            event.stopPropagation();
        }
    };

    //respond to refreshing the quote queue when scenarios change
    $scope.$on(quoteCreationEvents.scenarioChanged, function(event, args) {
        //at this point we have switched the "scenario/proposal" chosen, so
        // we need to refresh the products and rates based on chosen
        // product options related to the items in the quote queue
        vehicleProductsProcessingService.GetEligibleProducts();
    });

    $scope.scrollToProduct = function(index) {
        var product = angular.element('[data-product-index="prod-'+ index +'"]')[0];
        product.scrollIntoView();
    };
    $scope.toggleProductNavigation = function() {
        $scope.navigationVisible = !$scope.navigationVisible;
    }

    $scope.toggleDefaultProducts = function(val){
        var oldVal = $scope.vehicleData.defaultProductsOnly;

        $scope.vehicleData.defaultProductsOnly = val ? 'true' : 'false';

        if (oldVal !== $scope.vehicleData.defaultProductsOnly){
            rateQuoteCoordService.VehicleData.defaultProductsOnly = $scope.vehicleData.defaultProductsOnly;
            vehicleProductsProcessingService.clearProducts(true);
            vehicleProductsProcessingService.GetEligibleProducts();
        }
    }

    $scope.$on(quoteCreationEvents.filteringProductsSelected, function(event, args){
        vehicleProductsProcessingService.clearProducts(true);
        vehicleProductsProcessingService.GetEligibleProducts();
    });

    //toggle if print checkbox is chosen or not
    $scope.togglePrint = function(divId, event){
        event.stopPropagation();
        var idx = $scope.printDivs.indexOf(divId);
        if (idx > -1){
            $scope.printDivs.splice(idx,1);
        }
        else {
            $scope.printDivs.push(divId);

        }
        var printButtonText = "Print Selected";
        if ($scope.printDivs.length <= 0)
            printButtonText = "Print Quotes";
        $rootScope.$broadcast(quoteCreationEvents.divSelectedToPrint,{printerText: printButtonText});
    }

    $scope.$on(quoteCreationEvents.showPrinterOnDiv, function(event,args){
        if (args.printAction == "Print Quotes")
            $scope.showPrinter = true;
        else if (args.printAction == "Print Selected")
            printDiv('rateGrid-');
        else {
            $scope.showPrinter = false;
            $scope.printDivs = [];
        }
    });

    function printDiv(divNames) {
        // TODO: We migh benefit from creating a shared service
        $scope.customerDataPrint = rateQuoteCoordService.CustomerData;
        var customerFirstName = '';
        var customerMiddleName = '';
        var customerLastName = '';
        if ($scope.customerDataPrint.BuyerInfo) {
            customerFirstName = $scope.customerDataPrint.BuyerInfo.firstName ? $scope.customerDataPrint.BuyerInfo.firstName : '';
            customerMiddleName = $scope.customerDataPrint.BuyerInfo.middleName ? $scope.customerDataPrint.BuyerInfo.middleName : '';
            customerLastName = $scope.customerDataPrint.BuyerInfo.lastName ? $scope.customerDataPrint.BuyerInfo.lastName : '';
        }
        else {
            //add business info
        }
        var vehicleYear = '';
        var vehicleMake = '';
        var vehicleModel = '';
        var vehicleMileage = '';
        var vehicleVIN = '';
        var printMMY = '';
        $scope.vehicleDataPrint = rateQuoteCoordService.VehicleData;
        if ($scope.vehicleDataPrint){
            vehicleYear = $scope.vehicleDataPrint.year ? $scope.vehicleDataPrint.year : '';
            vehicleMake = $scope.vehicleDataPrint.makeName ? $scope.vehicleDataPrint.makeName : '';
            vehicleModel = $scope.vehicleDataPrint.modelName ? $scope.vehicleDataPrint.modelName : '';
            vehicleMileage = $scope.vehicleDataPrint.odometer ?  $scope.vehicleDataPrint.odometer.toLocaleString('en') + ' Miles' : '';
            vehicleVIN = $scope.vehicleDataPrint.vin ? $scope.vehicleDataPrint.vin : '';
        };
        if (vehicleYear && vehicleMake && vehicleModel && vehicleMileage){
            printMMY = vehicleYear + ' ' + vehicleMake + ' ' + vehicleModel + ', ' + vehicleMileage;
        }
        else{
            printMMY = vehicleVIN;
            vehicleVIN = '';
        }
        var quoteDate = privateFormatDateMMDDYYYY($scope.vehicleDataPrint.dateOfSale ? $scope.vehicleDataPrint.dateOfSale : Date());
        var dealerName = imSessionVarsService.getCurrentDealerIMName();
        var vehicleProducts = $scope.vehicleProductInfo;

        var printTemplate = '<!DOCTYPE html><html style="visibility:visible"><head><link href="../../assets/lib/angular-material/angular-material.min.css" rel="stylesheet"/><link href="../../assets/style/style.css" rel="stylesheet"/><link rel="stylesheet" href="../../assets/lib/bootstrap/dist/css/bootstrap.min.css"><script src="../../assets/lib/angular/angular.js"></script><script src="../../assets/lib/angular-animate/angular-animate.js"></script></head><body style="height:auto; width: auto; overflow: visible; display: block" onload="window.print(); window.close();"><div class="logo-commerce-dark flex" flex=""></div>' +
            '<div style="width:100%; display:flex">' +
                '<div style="width:50%">' +
                    '<h3>' + customerFirstName + ' ' + customerMiddleName + ' ' + customerLastName + '</h3>' +
                '</div>' +
                '<div style="width: 50%; float:right">' +
                    '<div style="display: inline-block">Prepared by: ' +
                    '</div>' +
                    '<div style="display: inline-block">' +
                        '<h3>' + dealerName + '</h3>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div  style="width:100%; display:flex">' +
                '<div style="width: 50%">' +
                    printMMY +
                '</div>' +
                '<div style="width: 50%, float: right, text-align: right">' +
                        quoteDate +
                '</div>' +
            '</div>' +
            '<div>' + vehicleVIN + '</div>' +
            '</br>' + '</br>' +
            '<div>innerContents</div></body></html>';

        var innerContents = null;

        $scope.printDivs.forEach(function print(divIndex){
            var divName = divNames + vehicleProducts.allProducts[divIndex].InternalProductId;// + divIndex;
            var covNameBody = '';
            var dedNameBody = '';
            var optNameHeader = '';
            var optNameBody = '';
            var baseNameHeader = '';
            var baseNameBody = '';
            var upgradecovNameHeader = '';
            var upgradecovNameBody = '';
            var upgradededNameHeader = '';
            var upgradededNameBody = '';
            var upgradeoptNameHeader = '';
            var upgradeoptNameBody = '';


                if (document.getElementById('coverages-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                    var covElement = '';
                    covElement = document.getElementById('coverages-' + vehicleProducts.allProducts[divIndex].InternalProductId);
                    covNameBody = '<td>' + covElement.getElementsByTagName("md-select-value")[0].textContent + '</td>';
                }
                else {
                    if (document.getElementById('coveragesSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                        covNameBody = '<td>' + document.getElementById('coveragesSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId).textContent + '</td>';
                    }
                }

                if (document.getElementById('deductibles-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                    var dedElement = '';
                    dedElement = document.getElementById('deductibles-' + vehicleProducts.allProducts[divIndex].InternalProductId);
                    dedNameBody = '<td>' + dedElement.getElementsByTagName("md-select-value")[0].textContent + '</td>';
                }
                else {
                    if (document.getElementById('deductiblesSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                        dedNameBody = '<td>' + document.getElementById('deductiblesSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId).innerText + '</td>';
                    }
                }

                if (document.getElementById('option-' + vehicleProducts.allProducts[divIndex].InternalProductId).childNodes[0].innerText != '') {
                    optNameHeader = '<th>OPTIONS/SURCHARGES</th>';
                    optNameBody = '<td>' + document.getElementById('option-' + vehicleProducts.allProducts[divIndex].InternalProductId).childNodes[0].innerText.replace(/(\r\n|\n|\r)/gm, "") + '</td>';
                }


                if (document.getElementById('baseterm-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                    baseNameHeader = '<th>BASETERM</th>';
                    var baseElement = '';
                    baseElement = document.getElementById('baseterm-' + vehicleProducts.allProducts[divIndex].InternalProductId);
                    baseNameBody = '<td>' + baseElement.getElementsByTagName("md-select-value")[0].textContent + '</td>';
                }
                else {
                    if (document.getElementById('basetermSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                        baseNameHeader = '<th>BASETERM</th>';
                        baseNameBody = '<td>' + document.getElementById('basetermSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId).innerText + '</td>';
                    }
                }

                if (document.getElementById('upgradecoverage-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                    upgradecovNameHeader = '<th>UPGRADE COVERAGE</th>';
                    var upgradecovElement = '';
                    upgradecovElement = document.getElementById('upgradecoverage-' + vehicleProducts.allProducts[divIndex].InternalProductId);
                    upgradecovNameBody = '<td>' + upgradecovElement.getElementsByTagName("md-select-value")[0].textContent + '</td>';
                }
                else {
                    if (document.getElementById('upgradecoverageSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                        upgradecovNameHeader = '<th>UPGRADE COVERAGE</th>';
                        upgradecovNameBody = '<td>' + document.getElementById('upgradecoverageSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId).innerText + '</td>';
                    }
                }

                if (document.getElementById('upgradedeductible-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                    upgradededNameHeader = '<th>UPGRADE DEDUCTIBLE</th>';
                    var upgradededElement = '';
                    upgradededElement = document.getElementById('upgradedeductible-' + vehicleProducts.allProducts[divIndex].InternalProductId);
                    upgradededNameBody = '<td>' + upgradededElement.getElementsByTagName("md-select-value")[0].textContent + '</td>';

                }
                else {
                    if (document.getElementById('upgradedeductibleSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId)) {
                        upgradededNameHeader = '<th>UPGRADE DEDUCTIBLE</th>';
                        upgradededNameBody = '<td>' + document.getElementById('upgradedeductibleSingle-' + vehicleProducts.allProducts[divIndex].InternalProductId).innerText + '</td>';
                    }
                }

                if (document.getElementById('upgrdoption-' + vehicleProducts.allProducts[divIndex].InternalProductId).childNodes[0].innerText != '') {
                    upgradeoptNameHeader = '<th>UPGRADE OPTIONS/SURCHARGES</th>';
                    upgradeoptNameBody = '<td>' + document.getElementById('upgrdoption-' + vehicleProducts.allProducts[divIndex].InternalProductId).childNodes[0].innerText.replace(/(\r\n|\n|\r)/gm, "") + '</td>';
                }

            var prodName = '<div style="text-color:red">' +
                            '<h3>' + vehicleProducts.allProducts[divIndex].DisplayName + '</h3>' +
                           '</div>';
            var tableOptions =
            '<table class="tux-table tux-table-condensed tux-table-striped tux-table-responsive">' +
                '<thead class="tux-color-accent">' +
                    '<tr>' +
                        '<th>COVERAGE</th>' +
                        '<th>DEDUCTIBLE</th>' +
                        optNameHeader +
                        baseNameHeader +
                        upgradecovNameHeader +
                        upgradededNameHeader +
                        upgradeoptNameHeader +
                    '</tr>' +
                '</thead>' +
                '<tbody>' +
                    '<tr class="rowBottom">' +
                        covNameBody +
                        dedNameBody +
                        optNameBody +
                        baseNameBody +
                        upgradecovNameBody +
                        upgradededNameBody +
                        upgradeoptNameBody +
                    '</tr>' +
                '</tbody>' +
            '</table>'

            innerContents = (innerContents != null ? innerContents : '') + prodName + tableOptions +  '<div style="text-align:center">' + document.getElementById(divName).innerHTML + '</div>';
        });

        printTemplate = printTemplate.replace('innerContents', innerContents);

        var popupWindow = window.open('', '_blank', 'scrollbars=yes,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWindow.document.open();
        popupWindow.document.write(printTemplate);
        popupWindow.document.close();
        //popupWindow.print();
        $rootScope.$broadcast(quoteCreationEvents.divSelectedToPrint,{printerText: "Close"});
        //return true;
    };

    var privateFormatDateMMDDYYYY = function(dt){
        //Splitting the date to get day instead of using ('0' + dt.getUTCDate()).slice(-2) which is dependent
        //on timezoneoffset and causes the incorrect day to be returned based on time of day
        var date = dt.toString().split(" ");
        var day = dt.getDate();
        var month = ('0' + (dt.getMonth() + 1)).slice(-2);
        var year = dt.getFullYear();

        return month + '/' + day + '/' + year;
    }

    $scope.$on(quoteCreationEvents.filteringProductsSelected, function(event, args){
        vehicleProductsProcessingService.clearProducts(true);
        vehicleProductsProcessingService.GetEligibleProducts();
    });

}]);
